import { PublicClientApplication } from "@azure/msal-browser";

class MSAL {
  account = undefined;
  token = undefined;
  loadingPromise = undefined;
  loading = false;
  isLoaded = false;
  appIdUri = "";
  msalInstance = undefined;
  msalConfig = undefined;

  constructor() {
    this.isLoaded = false;
    this.setup();
  }

  async ensureSetup() {
    if (!this.isLoaded) {
      await this.setup();
    }
  }
  manualPromise() {
    let resolveFn, rejectFn;

    const promise = new Promise((resolve, reject) => {
      resolveFn = resolve;
      rejectFn = reject;
    });

    return { promise, resolve: resolveFn, reject: rejectFn };
  }

  async setup() {
    if (
      this.loadingPromise !== undefined ||
      this.isLoaded === true ||
      this.loading === true ||
      this.msalInstance !== undefined
    )
      return this.loadingPromise;

    this.loadingPromise = this.manualPromise();
    this.loading = true;
    let config = await this.loadConfig();
    // either the config didn't exist or it was invalid
    if (config === undefined) return;

    this.msalConfig = {
      auth: {
        clientId: config.frontend_client_id,
        authority:
          config?.authority ??
          "https://login.microsoftonline.com/" + config.tenant_id,
        redirectUri: config.redirect_uri,
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
      },
    };

    localStorage.setItem("msalConfig", JSON.stringify(this.msalConfig));
    this.appIdUri = config.app_id_uri;

    if (this.msalInstance === undefined) {
      this.msalInstance = new PublicClientApplication(this.msalConfig);
      await this.msalInstance.initialize();
    }

    this.isLoaded = true;
    this.loading = false;
    this.loadingPromise.resolve();
  }

  get isAuthenticated() {
    return this.account !== undefined;
  }

  // private
  loginRequest = {
    scopes: ["openid", "profile", "email", "offline_access"],
  };

  getLoginRequest() {
    const lr = { ...this.loginRequest };
    lr.scopes.push(this.appIdUri);

    return lr;
  }

  getCachedConfig() {
    if (localStorage.getItem("msalConfig") === null) {
      return undefined;
    }

    return JSON.parse(localStorage.getItem("msalConfig"));
  }

  async loadConfig() {
    try {
      return await fetch("/authConfig.json").then((resp) => resp.json());
    } catch (error) {
      console.error("Error loading config file", error);
      return undefined;
    }
  }

  async login() {
    if (!this.isLoaded) {
      console.error("MSAL not loaded retry later");
      return false;
    }

    if (this.token !== undefined) return true;

    try {
      await this.msalInstance?.loginPopup(this.getLoginRequest());
    } catch (error) {
      console.error("Unable to open login popup", error);
      return false;
    }
    return true;
  }

  async getToken() {
    try {
      if (this.token !== undefined) return this.token;

      if (
        this.loadingPromise !== undefined &&
        Object.keys(this.loadingPromise).length > 0
      )
        await this.loadingPromise.promise;

      await this.setup();

      this.account = this.msalInstance.getAllAccounts()[0];
      if (this.account == undefined) {
        console.error("[EntraID] No account found", this.msalInstance);

        await this.login();
        return undefined;
      }

      const accessTokenResponse = await this.msalInstance.acquireTokenSilent({
        ...msal.getLoginRequest(),
        account: this.account,
      });
      return accessTokenResponse?.accessToken ?? undefined;
    } catch (error) {
      console.error("Error getting token", error);
      return undefined;
    }
  }
}

const msal = new MSAL();
export default msal;

export const msalPlugin = {
  async install(app) {
    // configure the app
    app.prototype.$msal = msal;
  },
};
